import * as Bowser from 'bowser'

export const Browser = Bowser.parse(navigator.userAgent)

export const isMozillaBrowser = Browser.browser.name?.toLowerCase() === 'firefox'
